import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navbar from '../components/Navbar';

export default function Cookies() {
    const navigate = useNavigate();
    return (
        <div className="app-wrap">
            <Helmet>
                <title>Cookie Policy | OnlineICO</title>
                <meta name="description" content="Read the Cookie Policy of OnlineICO. Learn how we use cookies and localStorage on our crypto presales directory." />
                <link rel="canonical" href="https://onlineico.com/cookies" />
            </Helmet>
            <Navbar />
            <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 1.5rem 80px' }}>
                <button onClick={() => navigate(-1)} style={{ background: 'none', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '30px', color: '#94a3b8', fontSize: '0.85rem', cursor: 'pointer', padding: '8px 16px', marginBottom: '32px' }}>← Back</button>

                <h1 style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '2rem', color: '#F1F5F9', marginBottom: '8px' }}>Cookie Policy</h1>
                <p style={{ color: '#64748b', fontSize: '0.85rem', marginBottom: '40px' }}>Last updated: April 2026</p>

                {[
                    {
                        title: '1. What Are Cookies?',
                        content: `Cookies are small text files stored on your device when you visit a website. They help websites remember your preferences, maintain sessions, and gather analytics data. Cookies can be session-based (deleted when you close your browser) or persistent (stored for a set period).`
                    },
                    {
                        title: '2. How OnlineICO Uses Cookies',
                        content: `OnlineICO uses cookies and similar technologies (such as localStorage) to: keep you logged in during your session, remember your preferences (language, filters), ensure the security of your account, and analyze Platform usage to improve our services.`
                    },
                    {
                        title: '3. Types of Cookies We Use',
                        content: `Essential cookies: Required for the Platform to function correctly. These include authentication tokens stored in localStorage to maintain your login session. Without these, features such as account management and project submission would not work. Analytics cookies: We may use anonymous analytics to understand how users interact with the Platform. These do not identify you personally. No advertising cookies: OnlineICO does not use advertising or tracking cookies from third-party ad networks.`
                    },
                    {
                        title: '4. localStorage',
                        content: `In addition to cookies, OnlineICO uses browser localStorage to store your authentication token (onlineico_token) and user profile data (onlineico_user). This data is stored locally on your device and is not transmitted to third parties. It is automatically cleared when you log out.`
                    },
                    {
                        title: '5. Managing Cookies',
                        content: `You can control and delete cookies through your browser settings. Please note that disabling essential cookies may affect the functionality of the Platform, including your ability to log in. Most browsers allow you to: view cookies stored on your device, delete individual or all cookies, block cookies from specific or all websites.`
                    },
                    {
                        title: '6. Third-Party Cookies',
                        content: `Some pages on the Platform may embed content from third-party services (e.g., YouTube videos for project presentations). These third parties may set their own cookies when you interact with their embedded content. We have no control over these cookies and recommend reviewing the respective privacy policies of these services.`
                    },
                    {
                        title: '7. Updates to This Policy',
                        content: `We may update this Cookie Policy from time to time to reflect changes in technology or legal requirements. We encourage you to review this page periodically.`
                    },
                    {
                        title: '8. Contact',
                        content: `If you have questions about our use of cookies, please contact us at contact@onlineico.com.`
                    },
                ].map((section, i) => (
                    <div key={i} style={{ marginBottom: '32px' }}>
                        <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '1.05rem', color: '#F1F5F9', marginBottom: '10px' }}>{section.title}</h2>
                        <p style={{ color: '#94a3b8', fontSize: '0.9rem', lineHeight: '1.8' }}>{section.content}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
